import React, { useState, useEffect } from 'react';
import {
  Row, Col, Tabs, Button, Typography,
} from 'antd';
import { useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { Footer } from 'antd/lib/layout/layout';
import {
  get, isSuperAgentError,
  RequestWrapper, ResponseWrapper,
} from '../../dataSource/requests';
import Background from '../sharedComponents/Background/Background';
import logo from '../../assets/images/new-campo-digital.png';
import './Login.scss';
import LoginComponent from './LoginComponent/LoginComponent';
import RegisterComponent from './RegisterComponent/RegisterComponent';
import { getUserRole, checkUserIsAuth } from '../../utils/users';
import { updateLinkLGPD, updateLinkPolicyAndCookiesUrl } from '../../redux/actions/app';

const Login = (): JSX.Element => {
  const navigate = useNavigate();
  const [enableHeaderClass, setEnableHeaderClass] = useState<string>('');
  const [isCookiesModalVisible, setIsCookiesModalVisible] = useState(false);
  const [linkCookies, setLinkCookies] = useState<string>('https://coopercitrus.com.br/politica-de-privacidade');
  const [linkLGPD, setlinkLGPD] = useState<string>('https://coopercitrus.com.br/lgpd/');

  const dispatch = useDispatch();

  useEffect(() => {
    if (checkUserIsAuth() && getUserRole() !== null) {
      navigate('/');
    }
  });

  useEffect(() => {
    if (!localStorage.getItem('cookiesAccepted')) {
      setIsCookiesModalVisible(true);
    }
  }, [isCookiesModalVisible]);

  const enableHeader = (enable: boolean): void => {
    setEnableHeaderClass(enable ? '' : 'remove-header');
  };

  const handleCookiesConfirmation = (): void => {
    setIsCookiesModalVisible(false);
    localStorage.setItem('cookiesAccepted', 'true');
  };

  const getLinkForHelp = async (): Promise<void> => {
    let response: ResponseWrapper | undefined;
    let responseError: ResponseWrapper | undefined;
    let genericError;

    const requestReference: RequestWrapper = get({
      url: '/system/getLinkForHelp',

      frontConfigs: {
        navigateFunction: navigate,
      },

      noAuth: true,
    });

    try {
      response = await requestReference;
    } catch (excep: unknown) {
      if (isSuperAgentError(excep)) {
        responseError = excep.response;
      } else {
        genericError = excep as Error;
      }
    }

    switch (true) {
      case (response?.body?.code === 8006):
        // "link need help retrieved successfully", 8006
        if (response?.body?.getLinkForHelpOutput?.policyAndCookiesUrl) {
          setLinkCookies(response?.body?.getLinkForHelpOutput?.policyAndCookiesUrl);
          localStorage.setItem('policyAndCookiesUrl', response?.body?.getLinkForHelpOutput?.policyAndCookiesUrl);
          dispatch(
            updateLinkPolicyAndCookiesUrl(
              response?.body?.getLinkForHelpOutput?.policyAndCookiesUrl,
            ),
          );
        }

        if (response?.body?.getLinkForHelpOutput?.lgpdUrl) {
          setlinkLGPD(response?.body?.getLinkForHelpOutput?.lgpdUrl);
          localStorage.setItem('lgpdUrl', response?.body?.getLinkForHelpOutput?.lgpdUrl);
          dispatch(updateLinkLGPD(response?.body?.getLinkForHelpOutput?.lgpdUrl));
        }
        break;

      case (genericError?.message?.includes('has been aborted')):
        // dont show anything when request is aborted
        break;

      case (responseError?.body?.code === -4000):
      default:
        // "Something unexpected happened", -4000
        break;
    }
  };

  useEffect(() => {
    getLinkForHelp();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="Login">
      <Row>
        <Col xs={{ span: 0 }} md={{ span: 14 }} className="login-background">
          <Background />
        </Col>
        <Col
          xs={{ span: 24 }}
          md={{ span: 10 }}
          className={`login-content ${enableHeaderClass}`}
        >
          <div className="login-container">
            <img className="logo-image" src={logo} alt="" />
            <Tabs
              defaultActiveKey="loginTab"
              centered
              animated
              className="Login__Tabs"
              destroyInactiveTabPane
            >
              <Tabs.TabPane
                tab="Fazer login"
                key="loginTab"
              >
                <LoginComponent />
              </Tabs.TabPane>
              <Tabs.TabPane
                tab="Cadastre-se"
                key="registerTab"
                className="center"
              >
                <RegisterComponent
                  enableHeader={enableHeader}
                />
              </Tabs.TabPane>
            </Tabs>
          </div>
          <Col className="links-lgpd" style={{ marginBottom: '30px' }}>
            <Col>
              <Typography.Text underline strong>
                <a href={linkCookies} target="_blank">Políticas de privacidade e cookies</a>
              </Typography.Text>
            </Col>
            <Col>
              <Typography.Text underline strong>
                <a href={linkLGPD} target="_blank">Lei Geral de Proteção de Dados</a>
              </Typography.Text>
            </Col>
          </Col>
        </Col>
      </Row>
      <Footer
        style={{
          borderTop: '1px solid #e8e8e8',
          position: 'fixed',
          left: 0,
          bottom: 0,
          width: '100%',
          fontSize: '16px',
          fontWeight: 'bold',
          textJustify: 'auto',
          backgroundColor: 'rgba(24,24,27,.733)',
          padding: '16px',
          display: !isCookiesModalVisible ? 'none' : 'block',
        }}
        className="cookieModalOnFooter"
      >
        <div className="cookieModalContainer">
          <div className="cookieWarningTextContainer">
            Utilizamos apenas cookies necessários para garantir o funcionamento esperado do nosso site. <br/> Ao continuar a navegar, você concorda com nossa política de privacidade.
          </div>
          <div className="cookieButtonContainer">
            <Button
              type="primary"
              htmlType="submit"
              className="btn-login"
              style={{ width: '250px' }}
              onClick={handleCookiesConfirmation}
            >
              OK
            </Button>
          </div>
        </div>
      </Footer>
    </div>
  );
};

Login.propTypes = {};

Login.defaultProps = {};

export default Login;
